



















import { ref, defineComponent, inject } from '@vue/composition-api'
import { editTextbookIssue, addCategory } from '@/shared/api'
import TextbookIssueForm from './TextbookIssueForm.vue'
import CloseButton from '@/components/custom/CloseButton.vue'
import { alertSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'EditTextbookIssue',
  components: {
    TextbookIssueForm,
    CloseButton,
  },
  props: {
    textbook: Object,
    textbookIssue: Object,
  },
  setup(props, context) {
    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const addCategoryHandler = async (name: string) => {
      const editedTextbook = await addCategory(props.textbookIssue.id, name)
      context.emit('textbook-issue-edited', editedTextbook)
    }

    const submit = async (formData: { file: string }) => {
      try {
        const data = {
          ...formData,
          textbookIssueId: props.textbookIssue.id,
        }
        if (data.file && props.textbookIssue.file) {
          await $alert({
            type: 'confirm',
            text: context.root.$t('textbookIssue.confirmNewPdf'),
          })
        }
        loading.value = true
        const editedTextbook = await editTextbookIssue(data)
        context.emit('textbook-issue-edited', editedTextbook)
        $alert({
          text: context.root.$t('textbookIssue.edited'),
          type: 'success',
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      loading,
      submit,
      addCategoryHandler,
    }
  },
})
